export function clearArray(array) {
  while (array.length > 0) {
    array.pop();
  }
}
